import React from 'react';
import { InputNumber, InputNumberProps } from 'antd';
import { useResponsiveSizes } from '../../../hooks/use-responsive-sizes';

export const ResponsiveInputNumber = (props: InputNumberProps) => {
  const { fontSize } = useResponsiveSizes();
  const sizeClass = `responsive-input-number-${Math.round(fontSize.base)}`;

  React.useEffect(() => {
    const styleId = `style-${sizeClass}`;

    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.innerHTML = `
        .${sizeClass} .ant-input-number-input {
          font-size: ${fontSize.base}px !important;
        }

        .${sizeClass} .ant-input-number-prefix,
        .${sizeClass} .ant-input-number-suffix {
          font-size: ${fontSize.base}px !important;
        }

        .${sizeClass}.ant-input-number {
          min-height: 40px !important;
        }
      `;
      document.head.appendChild(style);
    }
  }, [fontSize.base, sizeClass]);

  return (
    <InputNumber
      {...props}
      className={`${sizeClass} ${props.className || ''}`}
      style={{
        width: '100%',
        ...props.style
      }}
    />
  );
};
